import { getTimestampSchemaVersion, } from '@verdant-web/common';
export function getLatestVersion(data) {
    var _a, _b;
    const timestamps = data.operations
        .map((op) => op.timestamp)
        .concat((_b = (_a = data.baselines) === null || _a === void 0 ? void 0 : _a.map((b) => b.timestamp)) !== null && _b !== void 0 ? _b : []);
    const latestVersion = timestamps.reduce((v, ts) => {
        const tsVersion = getTimestampSchemaVersion(ts);
        if (tsVersion > v) {
            return tsVersion;
        }
        return v;
    }, 1);
    return latestVersion;
}
//# sourceMappingURL=versions.js.map